var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#1756E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 7.68115C9.23981 7.68115 6.02849 10.0089 4.72742 13.2948C6.02849 16.5806 9.23981 18.9084 13.0001 18.9084C16.7605 18.9084 19.9718 16.5806 21.2729 13.2948C19.9718 10.0089 16.7605 7.68115 13.0001 7.68115ZM13.0001 17.0372C10.9244 17.0372 9.23981 15.3606 9.23981 13.2948C9.23981 11.229 10.9244 9.55236 13.0001 9.55236C15.0758 9.55236 16.7605 11.229 16.7605 13.2948C16.7605 15.3606 15.0758 17.0372 13.0001 17.0372ZM13.0001 11.0493C11.7517 11.0493 10.7439 12.0523 10.7439 13.2948C10.7439 14.5373 11.7517 15.5402 13.0001 15.5402C14.2486 15.5402 15.2563 14.5373 15.2563 13.2948C15.2563 12.0523 14.2486 11.0493 13.0001 11.0493Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsOutline);
export default __webpack_public_path__ + "static/media/detailsOutline.e992bf43ce1a3a3f5c827d52b4303f33.svg";
export { ForwardRef as ReactComponent };